module.exports = {
  text: `Каждый вор знает парочку историй про слишком большие сокровища, чтобы их можно было утащить. Вы думаете что видели великолепие? Залы пашей Калимшана, или может быть, какого–то патриция из Врат Балдура? Скажу вам, Вы не видели ничего. Это всё — лачуги по сравнению с залами скьеётунов.`,
  author: `Воло`,
}
